import React from 'react';
import InterAccountTransfers from '../components/dashboard/InterAccountTransfers';

const Transfers: React.FC = () => {
  return (
    <div className="transfers-page py-8 px-4 md:px-12">
      <h1 className="text-2xl font-bold mb-8">All Transfers</h1>
      <InterAccountTransfers />
    </div>
  );
};

export default Transfers;
